import { render, staticRenderFns } from "./App.vue?vue&type=template&id=83bd736a"
import script from "./scripts.js?vue&type=script&lang=js&external"
export * from "./scripts.js?vue&type=script&lang=js&external"
import style0 from "./App.vue?vue&type=style&index=0&id=83bd736a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports